import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/kibana.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class Kibana extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 64 64' />
  }
}
